<template>
    <div class='line' ref='line'>
        <div class='col col1' @click='goToUserPage()'>{{ userObj.name }}</div>
        <div class='col col2' @click='goToUserPage()'>{{ userObj.firstName }}</div>
        <div class='col col3'>{{ userObj.mail }}</div>
        <div class='col col4'>{{ getRoleString(userObj.role) }}</div>
        <div class='col col5' :style="{'width': col4Width+'px'}">{{userObj.note}}</div>

        <button class="mdl-button mdl-js-button mdl-button--icon btn_keysub btnKey" v-if="hasApiKey" @click='goToUserPage()'>
            <i class="material-icons">vpn_key</i>
        </button>

        <button class="mdl-button mdl-js-button mdl-button--icon btn_editsub btnEdit" @click='clicEditUser()'>
            <i class="material-icons">edit</i>
        </button>

        <button class="mdl-button mdl-js-button mdl-button--icon btn_deletesub btnDelete" @click='clicDeleteUser()'>
            <i class="material-icons">delete</i>
        </button>

        <button class="mdl-button mdl-js-button mdl-button--icon btn_viewsub btnView" @click='goToUserPage()'>
            <i class="material-icons">visibility</i>
        </button>
    </div> 
</template>

<script>
    import FctUtils from '@/components/FctUtils';
    import { RoleEnum } from '../classes/enums';
    import axios from 'axios'
    import { diagonalbackURL, defaultConfig } from "../constantes";

    export default {
        name: "UserLine",
        mixins: [FctUtils],
        props:{
            userObj: {type:Object},
        },
        data(){
            return {
                col4Width:100,
                hasApiKey : false,
            }
        },
        mounted(){
            this.onResize();
        },
        created() {
            window.addEventListener("resize", this.onResize);

            this.onResize()

            axios(diagonalbackURL + "/users/"+ this.userObj.id + "/apikeys",  defaultConfig)
            .then(reponse => {
                if (reponse.data != undefined &&  reponse.data.length > 0) {
                    this.hasApiKey = true;
                }
            })
            .catch(error => this.errorHandler(error));
        },
        methods:{
            goToUserPage(){
                this.$router.push({name:"User", params: {userId: this.userObj.id} })
            },
            clicDeleteUser() {     
                this.emitter.emit('showPLForm', {mode:'formUser_remove', data:this.userObj});
            },
            clicEditUser() {
                //this.$root.$emit('showPLForm', {mode:'formUser_edit', data:this.userObj});
                this.emitter.emit('showPLForm', {mode:'formUser_edit', data:this.userObj});
            },
            onResize(){
                var calcWidth = 100;
                if (this.$refs.line != undefined ) {
                    calcWidth = this.$refs.line.clientWidth -113-111-171-10 - 60; // largeurs des autres col + padding
                }
                this.col4Width = calcWidth;
            },
            getRoleString(role) {
                switch(role) {
                    case "SUPERADMIN" : return RoleEnum.SUPERADMIN.string;
                    case "ADMIN" : return RoleEnum.ADMIN.string;
                    case "LINGUIST" : return RoleEnum.LINGUIST.string;
                }
                return "role error"
            }, 
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


/* Client Page */


.header_line {
    overflow:hidden;
}

.btnDelete {
    position: absolute;
    top:5px;
    right:25px;
}

.btnEdit {
    position: absolute;
    top:5px;
    right:45px;

    color: #0075bb;
}

.btnView {
    position: absolute;
    top:5px;
    right:5px;

    color: #0075bb;
}

.btnKey {
    position: absolute;
    top:5px;
    right:63px;

    color: #349326;
}

/* UserTab col:not(.header_col) uniquement*/

#userTab.pl-list .content {
	overflow-y: auto;
}

#userTab  .col1 {
    width : 100px;
}

#userTab .col2 {
    width: 100px;
    border-right-width: 1px;
}

#userTab .col3 {
    width: 160px;
    text-align: left;
    padding-left: 8px;
}  

#userTab .col4 {
    text-overflow: ellipsis;
    overflow: hidden;
}




</style>
